import { createSlice } from '@reduxjs/toolkit'
import { NetworkModel, RewardConfigModel, TokenModel } from 'services/types/Application'
import { InvestorModel } from 'services/types/Market'
import { CabitalAssetsConfigRes, CoinModel, GPKTKModel } from 'services/types/User'
import { networkListThunk, rewardConfigThunk, setAssetsConfig, tokenListThunk } from './actions'

export type PopupContent = {
  txn: {
    hash: string
  }
}

export interface SwapLimit {
  numLimit: number
  maxLimit: number
  minLimit: number
}

export enum ApplicationModal {
  WALLET,
  STAKE_CONFIRMATION,
  CONFIRM_ORDER,
  CONFIRM,
  COMMON_CONFIRM,
  TIPS_ALERT,
  WALLET_NEW_CRYPTO,
  COMPLAINT,
  COMPLAINT_USER,
  // nft 碎片合成弹窗
  NFT_FRAGMENT_COMPOUND,
  // 充值
  Instant_Deposit,
  PRICE_ALERT,
  // mobile menu
  MOBILE_MENU,
  // mobile menu
  MOBILE_USER_MENU,
  // Reward
  REWARD,
  CABITAL,
  INSUFFICIENT_BALANCE,
  FASS_MODAL,
  BUY_CRYPTO,
  PURCHASE_SUCCESSFUL,
}
export interface WalletModalInfoModel {
  type?: 'deposit' | 'withdraw' | 'swap' | 'swap-game' | '' | 'swap-gpktk'
  coinInfo?: CoinModel | null
  tokenInfo?: CoinModel | null
  gpktk?: GPKTKModel[] | null
}

export interface ApplicationState {
  readonly blockNumber: { readonly [chainId: number]: number }
  readonly openModal: ApplicationModal | null
  readonly tokenDecimals: Array<TokenDecimals>
  readonly assetsConfig: CabitalAssetsConfigRes
  readonly networkList: Array<NetworkModel>
  readonly gameMenus: Array<InvestorModel>
  readonly usdPrice: string | number
  readonly accountModal: string
  readonly previousUrl: string
  readonly homePlayId: string
  readonly rewardConfig: RewardConfigModel
  readonly tokenList: Array<TokenModel>
  readonly swapLimit: SwapLimit
  readonly walletModalInfo: WalletModalInfoModel
  readonly faasParams: FaasParamsModel
  uiMode: 'light' | 'dark'
  // globalAnnouncement: boolean
}

export interface TokenDecimals {
  symbol: string
  decimals: number
}

export interface FaasParamsModel {
  fiat: string
  amount: string
  quantity: string
}

const initialState: ApplicationState = {
  blockNumber: {},
  tokenList: [],
  networkList: [],
  tokenDecimals: [],
  gameMenus: [],
  openModal: null,
  // openModal: null,
  usdPrice: '0',
  accountModal: 'close',
  homePlayId: '',
  walletModalInfo: {
    type: '', // deposit withdraw swap | swap-game swap-gpktk
    coinInfo: null,
    tokenInfo: null,
    gpktk: null,
  },
  previousUrl: '',
  swapLimit: {
    numLimit: 0,
    maxLimit: 0,
    minLimit: 0,
  },
  rewardConfig: {
    openContentReward: false,
    openUserReward: false,
    rewardAmounts: [],
  },
  assetsConfig: {
    currencies: [],
    pairs: [],
  },
  uiMode: 'light',
  faasParams: {
    fiat: '',
    amount: '',
    quantity: '',
  },
  // globalAnnouncement: window.sessionStorage.getItem('globalAnnouncement') === 'false' ? false : true,
}

const applicationSlice = createSlice({
  name: 'application',
  initialState,
  extraReducers: builder => {
    builder.addCase(setAssetsConfig.fulfilled, (state, { payload }) => {
      if (payload.code === 200) {
        state.assetsConfig = payload.data
      }
    })
    builder.addCase(tokenListThunk.fulfilled, (state, { payload }) => {
      if (payload.code === 200) {
        state.tokenList = payload.data
      }
    })
    builder.addCase(rewardConfigThunk.fulfilled, (state, { payload }) => {
      if (payload.code === 200) {
        state.rewardConfig = payload.data
      }
    })
    builder.addCase(networkListThunk.fulfilled, (state, { payload }) => {
      if (payload.code === 200) {
        state.networkList = payload.data
      }
    })
  },
  reducers: {
    setHomePlayId(state, action) {
      state.homePlayId = action.payload
    },
    setOpenModal(state, action) {
      state.openModal = action.payload
    },
    setUsdPrice(state, action) {
      state.usdPrice = action.payload
    },
    setAccountModal(state, action) {
      state.previousUrl = window.location.href
      state.accountModal = action.payload
    },
    setWalletModal(state, action) {
      state.walletModalInfo = action.payload
    },
    setGameMenus(state, action) {
      state.gameMenus = action.payload
    },
    setTokenDecimals(state, action) {
      state.tokenDecimals = action.payload
    },
    setUIMode(state, action) {
      state.uiMode = action.payload
    },
    setSwapLimit(state, action) {
      state.swapLimit = action.payload
    },
    setFaasParams(state, action) {
      state.faasParams = action.payload
    },
    // setGlobalAnnouncement(state, action) {
    //   state.globalAnnouncement = action.payload
    // },
  },
})

export const {
  setOpenModal,
  setTokenDecimals,
  setUsdPrice,
  setAccountModal,
  setFaasParams,
  setUIMode,
  // setGlobalAnnouncement,
  setGameMenus,
  setSwapLimit,
  setWalletModal,
  setHomePlayId,
} = applicationSlice.actions
export default applicationSlice.reducer
